<template>
  <router-view />
</template>

<script>
  export default {
    name: 'formSystem',
  }
</script>

